import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { NgxMaskModule } from 'ngx-mask';
import { UserModule } from '../user/user.module';
import { RolesModule } from '../roles/roles.module';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FreeTrialRoutingModule } from './freetrial-routing.module';
// import { ClientListComponent, ClientDetailsDialog } from './client-list/client-list.component';
import { DataSetupComponent } from './data-setup/data-setup.component';
import { SendInviteDialogueComponent } from './sent-invite-dialogue/send-invite-dialogue.component';
// import { ClientInfoComponent } from './client-info/client-info.component';
import { ClientConnectionComponent } from './client-connection/client-connection.component';
import { OtherDocumentComponent } from './other-document/other-document.component';
import { ClientInfoComponent } from './client-info/client-info.component';
// import { AddClientComponent } from './add-client/add-client.component';
import { SelectRolesComponent } from './select-roles/select-roles.component';
import { CreateClientComponent } from './create-client/create-client.component';
import { TabViewModule } from 'primeng/tabview';
import { CompanyInfoComponent } from './company-info/company-info.component';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputTextModule } from 'primeng/inputtext';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { DividerModule } from 'primeng/divider';
import { CheckboxModule } from 'primeng/checkbox';
//import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { FileUploadLibraryModule } from 'file-upload-library';
import { SharedModule } from '../shared/shared.module';
import { SummaryInfoComponent } from './summary-info/summary-info.component';
import { CreatingUsersComponent } from './creating-users/creating-users.component';
import { TableModule } from 'primeng/table';
import { MenuModule } from 'primeng/menu';

import { RadioButtonModule } from 'primeng/radiobutton';
import { PaginatorModule } from 'primeng/paginator';
import { ButtonModule } from 'primeng/button';
import { ManageBeneficiaryComponent } from './manage-beneficiary/manage-beneficiary.component';
import { ClientListComponent } from './client-list/client-list.component';
import { AddClientCompanyComponent } from './add-client-company/add-client-company.component';
import { AddClientCompanyFormComponent } from './add-client-company-form/add-client-company-form.component';
import { ClientCompanyComponent } from './client-company/client-company.component';
import { AddUserComponent } from './add-user/add-user.component';
import { InviteBeneAttorneyComponent } from './invite-bene-attorney/invite-bene-attorney.component';
import { FirmInfoAttorneyComponent } from './firm-info-attorney/firm-info-attorney.component';
import { SendInviteAttorneyComponent } from './send-invite-attorney/send-invite-attorney.component';
import { DialogModule } from 'primeng/dialog';
import { EditClientCompanyFormComponent } from './edit-client-company-form/edit-client-company-form.component';
import { EditorModule } from '@progress/kendo-angular-editor';
import { CustomKendoModule } from '../custom-kendo/custom-kendo.module';
import { TooltipModule } from 'primeng/tooltip';
@NgModule({
  declarations: [DataSetupComponent, SendInviteDialogueComponent, ClientListComponent, ClientConnectionComponent,
    CreateClientComponent, CompanyInfoComponent, SelectRolesComponent,
    OtherDocumentComponent, SummaryInfoComponent,
    ClientInfoComponent, CreatingUsersComponent, ManageBeneficiaryComponent, AddClientCompanyComponent, AddClientCompanyFormComponent, ClientCompanyComponent, AddUserComponent, InviteBeneAttorneyComponent, FirmInfoAttorneyComponent, SendInviteAttorneyComponent, EditClientCompanyFormComponent,],
  imports: [
    CommonModule,
    DialogModule,
    CustomKendoModule,
    FreeTrialRoutingModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDividerModule,
    MatSelectModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatSortModule,
    MatStepperModule,
    MatTooltipModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatTabsModule,
    FormsModule,
    UserModule,
    RolesModule,
    NgxMaskModule.forRoot({
      validation: true,
    }),
    MatIconModule,
    FileUploadModule,
    MultiSelectModule,
    InputTextModule,
    CalendarModule,
    DropdownModule,
    DividerModule,
    CheckboxModule,
    TableModule,
    //FroalaEditorModule.forRoot(),
    //FroalaViewModule.forRoot(),
    FileUploadLibraryModule,
    NgxMaskModule.forRoot({
      validation: true,
    }),
    MatIconModule,
    TableModule,
    MenuModule,
    RadioButtonModule,
    PaginatorModule,
    ButtonModule,
    ConfirmDialogModule,
    TabViewModule,
    EditorModule,
    TooltipModule
  ],
  providers: [],
  entryComponents: [],
})
export class FreeTrialModule { }
